import {
  Box,
  Button,
  Center,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import { Trans, t } from "@lingui/macro";
import { TASK_ROW_HEIGHT } from "@src/components/modules/resource-planning/tasks/listing/components/task-row";
import { LoadingOverlay, Select } from "@src/components/ui-kit";
import { TaskItemProject } from "@src/components/ui-kit/TaskItem/TaskItemProject";
import { observer } from "mobx-react-lite";
import type { ProjectCreateTasksFromTemplateGroupStore } from "./store";

type Props = {
  store: ProjectCreateTasksFromTemplateGroupStore;
  isProjectTemplate?: boolean;
};
export const CreateTasksFromTaskTemplateGroupModal = observer(
  function CreateTasksFromTaskTemplateGroupModal({
    store,
    isProjectTemplate,
  }: Props) {
    return (
      <Modal
        isOpen={store.disclosure.isOpen}
        onClose={store.disclosure.onClose}
        scrollBehavior="inside"
        trapFocus={false}
      >
        <ModalOverlay />
        <ModalContent minW="80dvw">
          <ModalHeader>
            <Trans>Create tasks from task group</Trans>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Select
              label={t`Budget item`}
              value={Array.from(store.selectedBudgetItemIds)}
              options={store.budgetItemOptions}
              onChange={store.handleSelectBudgetItems}
              asPortal
              isMulti
              isClearable
              topExtraContent={
                store.showSelectAllButton ? (
                  <Button
                    p="2"
                    onClick={store.handleSelectAllBudgetItems}
                    variant="link"
                  >
                    <Trans>Select all</Trans>
                  </Button>
                ) : null
              }
            />
            <Box mt="2">
              <Select
                label={t`Task template group`}
                value={store.taskGroupTemplateId.value}
                options={store.taskGroupOptions}
                onChange={store.handleSelectTaskGroupTemplate}
                isLoading={store.groupsSimpleFetcher.isLoading.value}
                asPortal
                isClearable
              />
            </Box>
            {store.taskGroupTemplateId.value && (
              <Box mt="2">
                <Text fontSize="md">
                  <strong>
                    <Trans>Tasks to be added</Trans>
                  </strong>
                </Text>
                <LoadingOverlay
                  isLoading={store.groupFetcher.isLoading.value}
                  position="absolute"
                  size="md"
                  minH={TASK_ROW_HEIGHT}
                >
                  {store.groupTemplateTasks.map((task) => (
                    <TaskItemProject
                      key={`selected-task-${task.id}`}
                      task={task}
                      onCreateSubtask={store.fetchTaskGroupTemplates}
                      isProjectTemplate={isProjectTemplate}
                    />
                  ))}
                  {store.groupTemplateTasks.length === 0 &&
                    !store.groupFetcher.isLoading.value && (
                      <Center>
                        <Text color="gray.600">
                          <Trans>No task templates in this group yet.</Trans>
                        </Text>
                      </Center>
                    )}
                </LoadingOverlay>
              </Box>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              mr="2"
              colorScheme="grey"
              isLoading={store.mutator.isLoading.value}
              onClick={store.disclosure.onClose}
              variant="ghost"
            >
              <Trans>Cancel</Trans>
            </Button>
            <Button
              isLoading={store.mutator.isLoading.value}
              onClick={store.handleConfirm}
            >
              <Trans>Create</Trans>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  },
);
